export default "images/javascript-logo.png";